import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "../context/CartContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/our-sourcing", label: "Sourcing" },
  { to: "/wholesale", label: "Wholesale" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const { count } = useCart();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  return (
    <nav
      data-testid="main-navbar"
      className="fixed top-0 left-0 w-full z-50 bg-[#FAF9F6]/90 backdrop-blur-xl border-b border-[#D5D1C5]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2">
          <span className="font-serif-display text-2xl md:text-3xl tracking-tight leading-none">
            EarthOrg
          </span>
          <span className="hidden md:inline-block text-[10px] tracking-overline uppercase text-[#7A7A7A] border-l border-[#D5D1C5] pl-2 ml-1">
            Ventures LLP
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-xs uppercase tracking-overline font-medium transition-colors ${
                  isActive ? "text-[#C84B31]" : "text-[#1A1A1A] hover:text-[#C84B31]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <button
            data-testid="cart-button"
            onClick={() => nav("/cart")}
            className="relative flex items-center gap-2 text-[#1A1A1A] hover:text-[#C84B31] transition-colors"
          >
            <ShoppingBag size={20} strokeWidth={1.5} />
            <span className="hidden md:inline text-xs uppercase tracking-overline">Cart</span>
            {count > 0 && (
              <span
                data-testid="cart-count-badge"
                className="absolute -top-2 -right-3 bg-[#C84B31] text-[#FAF9F6] text-[10px] w-5 h-5 flex items-center justify-center rounded-full font-medium"
              >
                {count}
              </span>
            )}
          </button>
          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            className="md:hidden"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#FAF9F6] border-t border-[#D5D1C5] px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-overline"
            >
              {l.label}
            </NavLink>
          ))}
        </div>
      )}
    </nav>
  );
}
